import React, { useEffect } from 'react';
import { IAmlz, Ic3neprima, Ic3prima } from 'types/amlz';

import { IcisStaty } from 'services/cisStaty';

import { EAmlzFormularSteps } from 'enums/amlz/amlzFormularSteps';

import C3neprima from './C3neprima';
import C3prima from './C3prima';

interface IC3 {
    C3dataPrima?: Ic3prima;
    C3dataNeprima?: Ic3neprima;
    countries?: IcisStaty[];
    nextStep: () => void;
    prevStep: () => void;
    SubmitFunc: <T extends keyof IAmlz['amlz']>(key: T, values: IAmlz['amlz'][T]) => void;
    isC6edit: string;
    prevTo3b: boolean;
    setPrevTo3b: (v: boolean) => void;
    setSaving: React.Dispatch<React.SetStateAction<boolean>>;
    c3lastStep: boolean;
    setC3lastStep: React.Dispatch<React.SetStateAction<boolean>>;
    isLegalEntity: boolean;
}

const C3: React.FC<IC3> = ({
    C3dataPrima,
    C3dataNeprima,
    countries,
    nextStep,
    prevStep,
    SubmitFunc,
    prevTo3b,
    setPrevTo3b,
    isC6edit,
    setSaving,
    c3lastStep,
    setC3lastStep,
    isLegalEntity
}) => {
    useEffect(() => {
        isC6edit === EAmlzFormularSteps.C3A && setC3lastStep(false);
        isC6edit === EAmlzFormularSteps.C3B && setC3lastStep(true);
        prevTo3b && setC3lastStep(true);
        prevTo3b && setPrevTo3b(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return !c3lastStep ? (
        <C3prima
            isLegalEntity={isLegalEntity}
            C3dataPrima={C3dataPrima}
            countries={countries}
            prevStep={prevStep}
            nextStep={nextStep}
            SubmitFunc={SubmitFunc}
            setC3lastStep={setC3lastStep}
            isC6edit={isC6edit}
            setSaving={setSaving}
        />
    ) : (
        <C3neprima
            isLegalEntity={isLegalEntity}
            C3dataNeprima={C3dataNeprima}
            countries={countries}
            nextStep={nextStep}
            SubmitFunc={SubmitFunc}
            setC3lastStep={setC3lastStep}
            isC6edit={isC6edit}
            setSaving={setSaving}
        />
    );
};

export default C3;
